import patterns from 'utils/patterns';
import { SegmentFieldItem } from 'utils/segment-field-item.interface';


/* eslint-disable */
export const descriptionSegmentData: Array<SegmentFieldItem> = [
  {
    'field_map': 'sho',
    "item_name": "descriptions.SHO",
    "type": "list",
    "title": "Short description",
    "hint_detail": "Up to 20 characters briefly describing product.",
    "hint_panel" : "Up to 20 characters briefly describing product.",
    "example": "Cold Air Intake Kit",
    "sequence": 1,
    "show_more": true,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 20,
        pattern: patterns.ANdescriptions,
        message: `Short product description must be no more than 20 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    'field_map': 'inv',
    "item_name": "descriptions.INV",
    "type": "list",
    "title": "Invoice description",
    "hint_detail": "Up to 40 characters briefly describing product often used on order invoices.",
    "hint_panel" : "Up to 40 characters briefly describing product often used on order invoices.",
    "example": "57 Series Gen 2 Cold Air Intake Kit",
    "sequence": 2,
    "show_more": true,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 40,
        pattern: patterns.ANdescriptions,
        message: `Invoice product description must be no more than 40 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    "field_map": "tle",
    "item_name": "descriptions.TLE",
    "type": "list",
    "title": "Title Description",
    "hint_detail": "Up to 200 describing other known terms or descriptions for product.",
    "hint_panel" : "Up to 200 describing other known terms or descriptions for product.",
    "example": "Oxygen sensor also known as O2 sensor or lambda sensor.",
    "sequence": 19,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 200,
        pattern: patterns.ANdescriptions,
        message: `Title description must be no more than 200 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    'field_map': 'des',
    "item_name": "descriptions.DES",
    "type": "list",
    "title": "Long description",
    "hint_detail": "Up to 80 characters describing the product.",
    "hint_panel" : "Up to 80 characters describing the product.",
    "example": "57 Series Gen 2 Cold Air Intake Kit",
    "sequence": 3,
    "show_more": true,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 80,
        pattern: patterns.ANdescriptions,
        message: `Long product description is required and must be no more than 80 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    'field_map': 'ext',
    "item_name": "descriptions.EXT",
    "type": "list",
    "title": "Extended description",
    "hint_detail": "Up to 240 characters extending the description of the product.",
    "hint_panel" : "Up to 240 characters extending the description of the product.",
    "example": "High performance handling and aggressive good looks. Lower center of gravity. Stop quicker, corner faster! Excellent ride quality.  Million-mile warranty.",
    "sequence": 4,
    "show_more": true,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 240,
        pattern: patterns.ANdescriptions,
        message: `Extended product description must be no more than 240 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    'field_map': 'asm',
    "item_name": "descriptions.ASM",
    "type": "list",
    "title": "Application summary",
    "hint_detail": "Up to 2,000 characters using abbreviated terms to describe fitment information for the product. Often used for price sheet descriptions.",
    "hint_panel" : "Up to 2,000 characters using abbreviated terms to describe fitment information for the product. Often used for price sheet descriptions.",
    "example": "Ford F-100 Base 1983, Ford F-150 Base 1983-1986, Ford F-250 Base 1983-1986",
    "sequence": 5,
    "show_more": true,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 2000,
        pattern: patterns.ANdescriptions,
        message: `Application summary must be no more than 2000 characters. No special characters allowed: []~|^\\*`,
        hint_detail: "Up to 2,000 characters using abbreviated terms to describe fitment information for the product. Often used for price sheet descriptions.",
      },
      'pies70' : {
        minLength: 0,
        pattern: patterns.ANdescriptions,
        message: `Application summary must be no more than 240 characters. No special characters allowed: []~|^\\*`,
        hint_detail: "Up to 240 characters using abbreviated terms to describe fitment information for the product. Often used for price sheet descriptions.",
      },
      'pies71' : {
        minLength: 0,
        pattern: patterns.ANdescriptions,
        message: `Application summary must be no more than 240 characters. No special characters allowed: []~|^\\*`,
        hint_detail: "Up to 240 characters using abbreviated terms to describe fitment information for the product. Often used for price sheet descriptions.",
      },
      'pies72' : {
        minLength: 0,
        pattern: patterns.ANdescriptions,
        message: `Application summary must be no more than 240 characters. No special characters allowed: []~|^\\*`,
        hint_detail: "Up to 240 characters using abbreviated terms to describe fitment information for the product. Often used for price sheet descriptions.",
      }
    },
    "lookup": null
  },
  {
    "field_map": "asc",
    "item_name": "descriptions.ASC",
    "type": "list",
    "title": "Associated comments",
    "hint_detail": "Up to 2000 characters, one product can have more than one associated comments and the sequence here will be delivered in exports.",
    "hint_panel" : "Up to 2000 characters, one product can have more than one associated comments and the sequence here will be delivered in exports.",
    "example": "Manufactured from a durable, glass-filled nylong, non-corrosive composite. Strong, yet lightweight design promotes quicker response. Provides an improvement in fuel efficiency on most vehicles.",
    "sequence": 6,
    "show_more": true,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 2000,
        pattern: patterns.ANdescriptions,
        message: `Associated comments must be no more than 2000 characters.  No special characters allowed: []~|^\\*`,

      }
    },
    "lookup": null
  },
  {
    "field_map": "fab",
    "item_name": "descriptions.FAB",
    "type": "list",
    "title": "Features and Benefits",
    "hint_detail": "Up to 240 characters for features and benefits.",
    "hint_panel" : "Up to 240 characters for features and benefits.",
    "example": "",
    "sequence": 8,
    "show_more": true,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 240,
        pattern: patterns.ANdescriptions,
        message: `Features and Benefits must be no more than 240 characters. No special characters allowed: []~|^\\*`
      },
    },
    "lookup": null,
  },
  {
    "field_map": "mkt",
    "item_name": "descriptions.MKT",
    "type": "list",
    "title": "Marketing description",
    "hint_detail": "Up to 2,000 characters for promotional marketing copy.",
    "hint_panel" : "Up to 2,000 characters for promotional marketing copy.",
    "example": "Provides a clean, smooth way to mount gauges. Models are molded in black plastic to prevent fading and cracking, ready to be painted to match your interior or custom color scheme.",
    "sequence": 7,
    "show_more": true,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 2000,
        pattern: patterns.ANdescriptions,
        message: `Marketing description must be no more than 2000 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    "field_map": "abr",
    "item_name": "descriptions.ABR",
    "type": "list",
    "title": "Abbreviated description",
    "hint_detail": "Up to 12 characters abbreviating the product description.",
    "hint_panel" : "Up to 12 characters abbreviating the product description.",
    "example": "Fltr2431",
    "sequence": 9,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 12,
        pattern: patterns.ANdescriptions,
        message: `Abbreviated description must be no more than 12 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    "field_map": "lab",
    "item_name": "descriptions.LAB",
    "type": "list",
    "title": "Label description",
    "hint_detail": "Up to 80 characters describing the product for labels.",
    "hint_panel" : "Up to 80 characters describing the product for labels.",
    "example": "57 Series Gen 2 Cold Air Intake Kit",
    "sequence": 10,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 80,
        pattern: patterns.ANdescriptions,
        message: `Label description must be no more than 80 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    "field_map": "key",
    "item_name": "descriptions.KEY",
    "type": "list",
    "title": "Key search words",
    "hint_detail": "Up to 40 characters briefly describing product often used on order invoices.",
    "hint_panel" : "Up to 40 characters briefly describing product often used on order invoices.",
    "example": "Cold Air Intake Kit",
    "sequence": 11,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 2000,
        pattern: patterns.ANdescriptions,
        message: `Key search words must be no more than 2000 characters. No special characters allowed: []~|^\\*`,
        hint_detail: "Up to 2000 characters briefly describing product often used on order invoices.",
      },
      'pies67' : {
        minLength: 0,
        maxLength: 2000,
        pattern: patterns.ANdescriptions,
        message: `Key search words must be no more than 2000 characters. No special characters allowed: []~|^\\*`,
        hint_detail: "Up to 2000 characters briefly describing product often used on order invoices.",
      },
      'pies70' : {
        minLength: 0,
        maxLength: 80,
        pattern: patterns.ANdescriptions,
        message: `Key search words must be no more than 80 characters. No special characters allowed: []~|^\\*`,
        hint_detail: "Up to 80 characters briefly describing product often used on order invoices.",
      },
      'pies71' : {
        minLength: 0,
        maxLength: 80,
        pattern: patterns.ANdescriptions,
        message: `Key search words must be no more than 80 characters. No special characters allowed: []~|^\\*`,
        hint_detail: "Up to 80 characters briefly describing product often used on order invoices.",
      },
      'pies72' : {
        minLength: 0,
        maxLength: 80,
        pattern: patterns.ANdescriptions,
        message: `Key search words must be no more than 80 characters. No special characters allowed: []~|^\\*`,
        hint_detail: "Up to 80 characters briefly describing product often used on order invoices.",
      }
    },
    "lookup": null
  },
  {
    "field_map": "shp",
    "item_name": "descriptions.SHP",
    "type": "list",
    "title": "Shipping restrictions",
    "hint_detail": "Up to 2,000 characters listing keywords or tags which describe the product. Separate each with a semi-colon.",
    "hint_panel" : "Up to 2,000 characters listing keywords or tags which describe the product. Separate each with a semi-colon.",
    "example": "Truck freight only.",
    "sequence": 12,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 2000,
        pattern: patterns.ANdescriptions,
        message: `Shipping restrictions must be no more than 2000 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    "field_map": "sla",
    "item_name": "descriptions.SLA",
    "type": "list",
    "title": "Slang description",
    "hint_detail": "Up to 2,000 describing other known terms or descriptions for product.",
    "hint_panel" : "Up to 2,000 describing other known terms or descriptions for product.",
    "example": "Oxygen sensor also known as O2 sensor or lambda sensor.",
    "sequence": 13,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 2000,
        pattern: patterns.ANdescriptions,
        message: `Slang description must be no more than 2000 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    "field_map": "uns",
    "item_name": "descriptions.UNS",
    "type": "list",
    "title": "UN/SPSC description",
    "hint_detail": "Up to 80 characters, the United Nations Standard Products & Services Code.",
    "hint_panel" : "Up to 80 characters, the United Nations Standard Products & Services Code",
    "example": null,
    "sequence": 14,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 80,
        pattern: patterns.ANdescriptions,
        message: `UN/SPSC description must be no more than 80 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    "field_map": "vmr",
    "item_name": "descriptions.VMR",
    "type": "list",
    "title": "VMRS description",
    "hint_detail": "Up to 80 characters, the vehicle maintenance reporting standard description. The VMRS is part of the American Trucking Association's structured coding system.",
    "hint_panel" : "Up to 80 characters, the vehicle maintenance reporting standard description. The VMRS is part of the American Trucking Association's structured coding system.",
    "example": "025-001-176",
    "sequence": 15,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 80,
        pattern: patterns.ANdescriptions,
        message: `VMRS description must be no more than 80 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    "field_map": "cap",
    "item_name": "descriptions.CAP",
    "type": "list",
    "title": "Caption",
    "hint_detail": "Up to 240 characters.",
    "hint_panel" : "Up to 240 characters.",
    "example": "",
    "sequence": 16,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 240,
        pattern: patterns.ANdescriptions,
        message: `Caption must be no more than 80 characters. No special characters allowed: []~|^\\*`
      },
    },
    "lookup": null,
  },
  {
    "field_map": "tra",
    "item_name": "descriptions.TRA",
    "type": "list",
    "title": "Transcription",
    "hint_detail": "Up to 2000 characters.",
    "hint_panel" : "Up to 2000 characters.",
    "example": "",
    "sequence": 17,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 2000,
        pattern: patterns.ANdescriptions,
        message: `Caption must be no more than 2000 characters. No special characters allowed: []~|^\\*`
      },
    },
    "lookup": null,
  },
  {
    "field_map": "def",
    "item_name": "descriptions.DEF",
    "title": "AAIA Part Type Description",
    "hint_detail": "Up to 80 describing other known terms or descriptions for product.",
    "hint_panel" : "Up to 80 describing other known terms or descriptions for product.",
    "example": "Oxygen sensor also known as O2 sensor or lambda sensor.",
    "sequence": 20,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 80,
        pattern: patterns.ANdescriptions,
        message: `AAIA Part Type description must be no more than 80 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    'field_map': 'ttp',
    "item_name": "descriptions.TTP",
    "type": "list",
    "title": "Technical Tips",
    "hint_detail": "Up to 240 characters.",
    "hint_panel" : "Up to 240 characters.",
    "example": "",
    "sequence": 21,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 240,
        pattern: patterns.ANdescriptions,
        message: `Technical Tips description must be no more than 240 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
  {
    'field_map': 'ttd',
    "item_name": "descriptions.TTD",
    "type": "list",
    "title": "Technical Tips Marketing Description",
    "hint_detail": "Up to 2000 characters.",
    "hint_panel" : "Up to 2000 characters.",
    "example": "",
    "sequence": 22,
    "show_more": false,
    'validation': {
      'pies65' : {
        minLength: 0,
        maxLength: 2000,
        pattern: patterns.ANdescriptions,
        message: `Technical Tips Marketing Description must be no more than 240 characters. No special characters allowed: []~|^\\*`
      }
    },
    "lookup": null
  },
];
/* eslint-enable */
